import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Personnel from 'src/models/personnel/Personnel';
import useFetch from 'use-http';
import _ from 'lodash';
import 'src/styles/pages/_accountsPayable.scss';
// icons
import { BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { BsLightningFill } from 'react-icons/bs';
import { FaFlagCheckered } from 'react-icons/fa';
import { MdFileUpload } from 'react-icons/md';
import { IoMdExit } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import LoadRawDataFileDialog from './LoadRawDataFileDialog';
import CreditCardType from 'src/models/AP/CreditCardType';
import ChargeIndividual from 'src/models/AP/ChargeIndividual';

interface ICreditCardStatementDialogProps {
    dialogName: string;
    handleSelectedPerson?: (person: ChargeIndividual) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    setFileToUpload?: (formData: FormData) => void;
    creditCardTypes: CreditCardType[];
}

const CreditCardStatementDialog = (props: ICreditCardStatementDialogProps) => {
    const dispatch = useDispatch();
    const { get, response } = useFetch();
    const { register, errors } = useForm();
    const [selectedPerson, setSelectedPerson] = useState<Personnel>(undefined);
    const [personnelList, setPersonnelList] = useState<Array<Personnel>>(undefined); // The whole personnel list
    const [personnelSearchResults, setPersonnelSearchResults] = useState<Array<Personnel>>(undefined); // The personnel filtered by search (Name)

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (personnelSearchResults) {
            console.log('Personnel SearchResults Updated', personnelSearchResults);
        }
    }, [personnelSearchResults]);

    const onCreate = () => {
        getPersonnel();
        console.log('CreditCardStatementDialog onCreate()', personnelList);
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    /**
     * Gets the list of Personnel Users and stores in personnelList
     */
    const getPersonnel = async () => {
        let result = await get(`/v1.0/landmen`);
        if (response.ok && result) {
            setPersonnelList(result.items);
            setPersonnelSearchResults(result.items);
        } else {
            console.log('Unable to get the Personnel Data!!! >:c');
        }
    };

    const buttonClick = () => {
        console.log('Button Clicked');
    };

    const loadRawDataFile = () => {
        console.log('loadRawDataFileButton Clicked');
        props.hideDialog();
        props.showDialog(DialogList.LOAD_RAW_DATA_FILE);
    };

    return (
        <Dialog title="Credit Card Statement Maintenance" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '60%' }}>
            <div className="form-row" style={{marginTop: '1rem'}}>
                <RHFInputBox  
                    label="Statement No." 
                    name={'statementNumber'} 
                    register={register} 
                    errors={errors} 
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '25%' }}
                />
                <RHFSelect 
                    label="Credit Card"
                    name={`creditCard`}
                    options={[
                        { value: 'Chase Southwest', label: 'Chase Southwest' },
                        { value: 'Other', label: 'Other' },
                    ]}
                    register={register} 
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '25%' }}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Query Data"
                    reactIcon={BsLightningFill}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => buttonClick}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Record"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => buttonClick}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Record"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => buttonClick}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Record"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => buttonClick}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Record"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => buttonClick}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Upload"
                    reactIcon={MdFileUpload}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                    onClick={() => loadRawDataFile()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Flaggy Thing"
                    reactIcon={FaFlagCheckered}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                    onClick={() => buttonClick}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Exit Form"
                    reactIcon={IoMdExit}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.2rem', height: '2.2rem', verticalAlign: 'center'}}
                    onClick={() => props.hideDialog()}
                />
            </div>
            <div className="form-row">
                <RHFInputBox  
                    label="Statement Date" 
                    name={'statementDate'} 
                    type="date"
                    register={register} 
                    errors={errors} 
                    style={{width: '100%'}} 
                />
                <RHFInputBox  
                    label="Period Dates" 
                    name={'periodDateStart'} 
                    type="date"
                    register={register} 
                    errors={errors} 
                    style={{width: '100%'}} 
                />
                <RHFInputBox 
                    labelOnLeft={true} 
                    label="to" 
                    name={'periodDateEnd'}
                    type="date"
                    register={register} 
                    errors={errors} 
                    labelStyle={{ marginTop: '2.1rem' }}
                    style={{width: '100%', marginTop: '1.8rem'}} 
                />
                <RHFInputBox  
                    label="Date Uploaded" 
                    name={'dateUploaded'} 
                    type="text"
                    register={register} 
                    errors={errors} 
                    style={{width: '100%'}} 
                />
                <RHFInputBox  
                    label="Proc. Date" 
                    name={'procDate'} 
                    type="text"
                    register={register} 
                    errors={errors} 
                    style={{width: '100%'}} 
                />
            </div>
            <div style={{marginTop: '3rem', overflowY: 'scroll', height: '20rem'}}>
                <form>
                    <table>
                        <thead style={{ textAlign: 'center' }}>
                            <tr>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '15%' }}>Transaction Type</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '5%' }}>Tran. Date</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '25%' }}>Transaction Description</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '5%' }}>Amount</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '15%' }}>Tran. No.</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '3%' }}>Charged By</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '10%' }}>Employee</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '5%' }}>Vendor No.</th>
                                <th className="find-person-header" style={{ fontSize: '9px', width: '15%' }}>Vendor Name</th>
                            </tr>
                        </thead>
                        {personnelSearchResults?.map((person: Personnel, index: number) => {
                            return (
                                <tbody key={person.id}>
                                    <tr 
                                        className="table-item-hover" 
                                        style={person?.id === selectedPerson?.id ? { background: 'yellow', textAlign: 'left' } : { textAlign: 'left' }} 
                                        onClick={() => setSelectedPerson(person)}
                                    >
                                        <td style={{ width: '15%' }}>
                                            <label>{person?.lastName}</label>
                                        </td>
                                        <td style={{ width: '5%' }}>
                                            <label>{person?.firstName}</label>
                                        </td>
                                        <td style={{ width: '25%' }}>
                                            <label>{person?.lmsNumber}</label>
                                        </td>
                                        <td style={{ width: '5%' }}>
                                            <label>{person?.lmsNumber}</label>
                                        </td>
                                        <td style={{ width: '15%' }}>
                                            <label>{person?.corporationName}</label>
                                        </td>
                                        <td style={{ width: '3%' }}>
                                            <label>{person?.corporationAddress?.city}</label>
                                        </td>
                                        <td style={{ width: '10%' }}>
                                            <label>{person?.corporationAddress?.state?.abbreviation}</label>
                                        </td>
                                        <td style={{ width: '5%' }}>
                                            <label>{person?.status}</label>
                                        </td>
                                        <td style={{ width: '15%' }}>
                                            <label>{person?.status}</label>
                                        </td>
                                    </tr>
                                </tbody>
                                );
                            })}
                    </table>
                </form>
                <LoadRawDataFileDialog 
                    dialogName={DialogList.LOAD_RAW_DATA_FILE} 
                    showDialog={showDialog}
                    hideDialog={hideDialog}
                    setFileToUpload={props.setFileToUpload}
                    creditCardTypes={props.creditCardTypes}
                />
            </div>
        </Dialog>
    );
};

export default CreditCardStatementDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/CreditCardStatementDialog.tsx